import type { State } from "@hookstate/core";
import { LoadingButton } from "@mui/lab"
import { Button, Grid } from "@mui/material"
import React from "react"
import useDispatchState from "~/features/Dispatch/stores/DispatchState";
import { useLang } from "~/hooks/useLang";

interface ActionsButtonsProps {
  readonly loadingForms: State<boolean>;
  readonly sendFormToSave: () => void;
  readonly onCancel: () => void;
}

export default function ActionsButtons({ loadingForms, sendFormToSave, onCancel }: ActionsButtonsProps) {
  const { translate } = useLang();
  const { dispatch } = useDispatchState();
  const { status } = dispatch();

  return (
    <Grid
      container
      xs={12}
      direction={'row'}
      justifyContent={'flex-end'}
      alignItems={'center'}
      sx={{ padding: 1 }}
    >
      <Button
        sx={{ marginRight: '8px' }}
        variant="outlined"
        disabled={status.value.id === 8}
        onClick={() => onCancel()}
      >
        {translate("Cancel")}
      </Button>

      <LoadingButton
        loading={loadingForms.get()}
        variant="contained"
        onClick={() => sendFormToSave()}
        sx={{ mr: 1 }}
        disabled={status.value.id === 8}
      >
        {translate('Save')}
      </LoadingButton>
    </Grid>
  )
}